module.exports = {"621025100":"山河镇","621025101":"榆林子镇","621025102":"宫河镇","621025103":"永和镇","621025104":"永正镇","621025105":"周家镇","621025106":"湫头镇","621025107":"西坡镇","621025204":"五顷原乡","621025205":"三嘉乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/621025.json
// module id = 2944
// module chunks = 0